import { render, staticRenderFns } from "./Banner4.vue?vue&type=template&id=714f349e&scoped=true&"
import script from "./Banner4.vue?vue&type=script&lang=js&"
export * from "./Banner4.vue?vue&type=script&lang=js&"
import style0 from "./Banner4.vue?vue&type=style&index=0&id=714f349e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714f349e",
  null
  
)

export default component.exports